<template>
  <div class="table-responsive">
    <table
      class="table table-striped table-sm table-bordered"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th class="text-center">CNPJ</th>
          <th>Nome</th>
          <th class="text-center">Num. Usuários</th>
          <th class="text-center">Contato</th>
          <th class="text-center">Status</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="company in companies" :key="company.id">
          <td class="text-center">{{ company.cnpj }}</td>
          <td>{{ company.nome }}</td>
          <td class="text-center">{{ company.numUsuario }}</td>
          <td class="text-center">
            {{ company.usuarioNome }} <br />{{ company.email }} <br />
            <span v-html="statusTranslate(company.usuarioStatus)" />
          </td>
          <td v-html="statusTranslate(company.status)" class="text-center" />
          <td class="text-center p-2">
            <button
              type="button"
              class="btn btn-outline-warning btn-icon"
              title="Editar"
              @click="$emit('createEditCompany', company.id)"
            >
              <i class="ph ph-pencil" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { statusTranslate } from '@/utils/strings'

export default {
  name: 'ListCompanies',

  props: {
    companies: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListCompanies',
        columnDefs: [
          {
            targets: [],
            orderable: false,
            width: 130,
          },
        ],
      },
      statusTranslate,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }
      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
